import { Injectable } from '@angular/core';
import { Payload } from '@karl/entities';
import { SnackbarService } from '../../shared/building-blocks/snackbar/snackbar.service';

@Injectable()
export class PayloadUtil {
  // Fehlermessage Priorität: 1 - expliziter Parameter im Client, 2 - Message von DMW/CMW, sonst Defaultmeldung
  private static defaultErrorMsg = 'Es ist ein Fehler aufgetreten. Versuchen Sie es bitte später nochmal.';
  private static defaultSuccessMsg = 'Erfolgreich durchgeführt';

  public static handlePayloadSnackbar<T extends Payload>(
    payload: T,
    snackbar: SnackbarService,
    successMsg: string = this.defaultSuccessMsg,
    failureMsg: string = this.defaultErrorMsg
  ): boolean {
    if (payload && payload.success && (<any>payload).data) {
      snackbar.showSnackBar(successMsg ? successMsg : this.defaultSuccessMsg);
      return true;
    }
    if (payload && payload.message && payload.message.text && failureMsg === this.defaultErrorMsg) {
      failureMsg = payload.message.text;
    }
    snackbar.showSnackBar(failureMsg ? failureMsg : this.defaultErrorMsg);
    return false;
  }

  public static handlePayloadSnackbarErrorOnly<T extends Payload>(
    payload: T,
    snackbar: SnackbarService,
    failureMsg: string = this.defaultErrorMsg
  ): boolean {
    if (payload && payload.success && (<any>payload).data) {
      return true;
    }
    if (payload && payload.message && payload.message.text && failureMsg === this.defaultErrorMsg) {
      failureMsg = payload.message.text;
    }
    snackbar.showSnackBar(failureMsg ? failureMsg : this.defaultErrorMsg);
    return false;
  }

  public static checkPayload<T extends Payload>(payload: T): boolean {
    return !!(payload && payload.success && (<any>payload).data);
  }
}
